<template>
    <div>
        <div
            class="l-ss-c-completions-inner"
            ref="inner">
            <p
                class="l-ss-c-completions-title"
                v-show="showEmptySkuOfferTitle">
                {{ $t('completions.interestTitle') }}
            </p>
            <ul
                class="l-ss-c-completions-tags-group"
                v-if="$screen.isMobile">
                <li
                    v-for="item in tags"
                    :key="item"
                    class="l-ss-c-completions-tags"
                    @click="handleTagsClick(item)">
                    {{ item }}
                </li>
            </ul>
            <div
                class="l-ss-c-completions-group"
                :class="{ [`l-ss-c-completions-group-${key}`]: ($configuration.completionsFullWidth && key === 'offers') }"
                v-for="(group, key , groupIndex) in groups"
                :key="groupIndex"
                @click="handleClick">
                <completions-item
                    v-for="(item, itemIndex) in group"
                    :key="item._id"
                    :data="item"
                    :is-active="itemIndex === activeIndex"
                    :is-cart-available="$configuration.features.addToCartButton"
                    :is-cat-prefix-active="$configuration.features.catPrefix"
                    :data-id="item._id"
                    :data-position="itemIndex + 1"
                    v-show="isItemVisible(item)"
                    @add-to-cart="offer => $emit('add-to-cart', offer)"
                    @remove-history="hint => $emit('remove-history', hint)"/>
            </div>
        </div>

        <div class="l-ss-c-completions-bar">
            <button
                v-if="showAllVisible && completions.length > 0"
                class="l-ss-c-completions-show-all"
                @click="$emit('search-all')">
                <span>
                    {{ $t('completions.showAll') }}
                </span>
            </button>
        </div>
        <div
            class="l-ss-c-completions-sku"
            v-show="$configuration.skuStrict && completions.length === 0">
            <p class="l-ss-c-completions-sku-empty-title">{{ $t('completions.emptyResultsBySku') }}</p>
            <button
                class="l-ss-c-button l-ss-c-button-large"
                @click="handleEmptyResetClick">
                {{ $t('categories.emptyListButtonResetQuery') }}
            </button>
        </div>
    </div>
</template>

<script>
    import CompletionsItem from './completions-item';
    import CompletionsTagsFactory from '../../mixins/completions-tags-factory';

    export default {
        components: {
            CompletionsItem,
        },
        mixins: [
            CompletionsTagsFactory,
        ],
        props: {
            completions: {
                type: Array,
                default: () => ([]),
            },
            showAllVisible: {
                type: Boolean,
                default: true,
            },
            query: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                activeIndex: null,
                dataSet: {},
                completionTarget: {},
            };
        },
        computed: {
            groups() {
                let groups = {};
                this.completions.forEach(completion => {
                    if (!groups[completion.label]) {
                        groups[completion.label] = [];
                    }
                    groups[completion.label].push(completion);
                });
                return groups;
            },
            allCompletionsHidden() {
                return this.completions.some(item => item.visible === true) === false;
            },
            showEmptySkuOfferTitle() {
                return this.skuStrict && this.allCompletionsHidden && this.isSku && this.completions.length > 0;
            },
            skuStrict() {
                return this.$configuration.skuStrict;
            },
            isSku() {
                return Boolean((this.query || '').match(this.$configuration.skuRegExp));
            },
        },
        watch: {
            completions: {
                handler() {
                    this.$refs.inner.scrollTo(0, 0);
                },
            },
        },
        methods: {
            handleTagsClick(tag) {
                this.$emit('handleTagsClick' , this.factoryQuery(this.query , tag));
            },
            isItemVisible(item) {
                return item.visible || this.allCompletionsHidden && this.skuStrict;
            },
            handleEmptyResetClick(event) {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('reset-query');
            },
            handleClick(event) {
                event.stopPropagation();
                if (this.completionTarget) {
                    const path = event.path || (event.composedPath && event.composedPath());
                    const completionTarget = path.find(element => element.dataset && element.dataset.id);
                    const dataSet = completionTarget.dataset;
                    if (completionTarget) {
                        const completion = this.completions.find(item => item._id && item._id === dataSet.id);
                        this.$emit('click', {
                            event: event,
                            completion: completion,
                            position: dataSet.position,
                        });
                    }
                }
            },
        },
    };
</script>
